export const pickupDateRuleApplies = (orderingDatePattern, orderPickupDate) => {
    if (!Array.isArray(orderingDatePattern) || orderingDatePattern.length !== 2) {
        return false;
    }
    if (typeof orderPickupDate !== 'string' || !orderPickupDate) {
        return false;
    }
    const [from, to] = orderingDatePattern;
    const isOpen = (v) => typeof v !== 'string' || v === '' || v.includes('*');
    const fromOk = isOpen(from) || orderPickupDate >= from;
    const toOk = isOpen(to) || orderPickupDate <= to;
    return fromOk && toOk;
};
export const effectiveDiscountForPickupDate = (applicableDiscounts, fallbackDiscount, pickupDate) => {
    const candidates = Array.isArray(applicableDiscounts) && applicableDiscounts.length > 0
        ? applicableDiscounts
        : fallbackDiscount
            ? [fallbackDiscount]
            : [];
    return candidates.find((discount) => {
        if (!discount)
            return false;
        if (discount.dateRule === 'pickupDate') {
            return pickupDateRuleApplies(discount.orderingDatePattern, pickupDate);
        }
        return true;
    });
};
